import React, { Component }  from 'react';
import Footer1 from "../components/Footers/Footer1.component";
import Header2 from "../components/Headers/Header2.component";

// components
import Banner1 from "../components/Banners/Banner1.component";
import LogosBanner from "../components/Banners/LogosBanner.component";
import PopularServices from "../components/PopularServices.component";
import Feedback from "../components/Feedback.component";
import CTAMobileApp from "../components/CallToActions/CTAMobileApp.component";
import HowItWorks from "../components/HowItWorks.component";
import BlogsList from "../components/Blogs/BlogsList.component";

export default function Home() {

  return (
    <>
      <section>
        <Header2 />
        <Banner1 />
        {/* <LogosBanner /> */}
        {/* <PopularServices /> */}

        <HowItWorks />
        <Feedback />
        <CTAMobileApp />
        <BlogsList />

        <Footer1 />
      </section>
    </>
  );
}
